import './MunMaual.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import HongButton from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Exam6FastSearch from '../page_exam/Exam6FastSearch';
import MunMaual_main from './MunMaual_main';
import HeaderTitle from '../comm/HeaderTitle';
import MunViewer from './MunViewer';
import Img2pdf from '../img2pdf/Img2pdf';
import { setIsModalSaveTestNew, setListCart, setIsKeepCart, setIsFastSearch_saveTest } from '../reduxToolkit/redux';

const MunMaual = ({setIsModal=false, direction=2 }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isKeepCart = useSelector((state) => state.reduxStore.isKeepCart);
  const isFastSearch_saveTest = useSelector((state) => state.reduxStore.isFastSearch_saveTest);
  const [list, setList] = useState([]);
  const [selectedUnitItem, setSelectedUnitItem] = useState({});
  const [isModal, setIsModalLocal] = useState(false); // 모달 상태 추가
  const [imgList, setImgList] = useState([]); // 이미지 리스트 추가
  const [isFastSearch, setIsFastSearch] = useState(false); // 빠른 검색 상태 추가

   const location = useLocation();


  useEffect(() => {

    const params = new URLSearchParams(location.search);
    const isModalSaveTestNew = params.get("isModalSaveTestNew");
    if (isModalSaveTestNew) {
      dispatch(setIsModalSaveTestNew(true)); 
      dispatch(setIsFastSearch_saveTest(false)); // 빠른 검색 상태 초기화
    }else {
      dispatch(setIsModalSaveTestNew(false));
      dispatch(setIsFastSearch_saveTest(false)); // 빠른 검색 상태 초기화
    }


  }, [location]); // location이 바뀔 때마다 실행


  useEffect(() => {
    if (!isKeepCart) {
      dispatch(setListCart([])); // 장바구니 초기화
    }
    dispatch(setIsKeepCart(false)); // 장바구니 유지 상태 초기화
}, [selectedUnitItem]);
//=========================================
  return (
  <S.Section className='Section-MunMaual00'>
    <div className='MunMaual'>

         {isFastSearch_saveTest && //setIsFastSearch 이건 사용 안 함 형식 상 
        <>
          <HeaderTitle onBackClick={() => setIsModal(false)} direction={direction} /> 
          <section className="section-bookMain">
            <Exam6FastSearch  setSelectedUnitItem={setSelectedUnitItem} setIsFastSearch={setIsFastSearch} />
          </section> 
          </>
        }
  
        {!isFastSearch_saveTest &&
          <>
           
            <section className="" > 
              <HeaderTitle onBackClick={() => dispatch(setIsFastSearch_saveTest(true))} direction={1} />
              {selectedUnitItem && 
              <MunMaual_main selectedUnitItem={selectedUnitItem} 
             />}
             
            </section>
          </>
        }

          {isModal && <S.Modal>
              <Img2pdf 
                imgList={imgList} 
                onClose={() => setIsModalLocal(false)}
              />
            </S.Modal>}
       

      

   </div>
  </S.Section>
  );
};

export default MunMaual;